import axios from 'axios'
import { APIBASE } from '../constant'
import { getLocaleApi } from './locale'

let region = getLocaleApi()
console.log('server region:', region)

export function sendFeedbackMissingPlace(name, label) {
  return axios
    .post(`${APIBASE}/feedback/missing_place?region=${region}`, {
      name: name,
      label: label
    })
}

export function getDetail(cid) {
  return axios.get(`${APIBASE}/detail/${cid}?region=${region}`)
}

export function getReviews(cid, aspect, sortBy) {
  let url = `${APIBASE}/reviews/${cid}?aspect=${aspect}&sort_by=${sortBy}&region=${region}`
  return axios.get(url)
}

export function sendFeedback(cid, rating) {
  return axios
    .get(`${APIBASE}/feedback/place/${cid}/${rating}?region=${region}`)
}

export function sendFeedbackDetail(cid, detail) {
  return axios
    .post(
      `${APIBASE}/feedback/detail/${cid}?region=${region}`,
      detail
    )
}

export function getSearchWrap(url) {
  return axios.get(url + `&region=${region}`)
}
